<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent">
    <app-popup-header></app-popup-header>
    <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
        <div class="row box" *ngFor="let item of items">
            <div class="col-12">
                <label class="en">{{item.key | localDate}}</label>
            </div>
            <div class="row styled_row" *ngFor="let itemSub of item.value">
                <div class="col-12">
                    <span [ngClass]="localService.getLanguageCode(itemSub.key)">{{itemSub.value}}</span>
                    <div class="lan_equiv">
                        {{localService.getEquivalentTitleById(itemSub.key)}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>